const LiveAgent = {
  List: "/Tables/LiveAgent/List",
  Info: "/Tables/LiveAgent/Info",
  Export: "/Tables/LiveAgent/Export",
};

export default {
  LiveAgent,
};
